import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/gif-compression-test";

export const Route = createFileRoute("/research/gif-compression-test")(options);